import dayjs from "@v2/lib/dayjs";

export default function formatDateToDDMMYYYY(date: Date) {
  return dayjs(date).format("YYYY-MM-DD");
}
